import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { FED_CREDIT_END, FED_NEW_CREDIT_LABEL } from '../../config/stats';

// Example out-the-door sheet. Line items mirror the Deal-Checker's own
// placeholder quote; the struck total is their sum (899 + 199 + 2,500 + 2,990).
const ROWS = [
  { label: 'Paint & fabric protection', amount: '$899', note: 'junk', d: 1 },
  { label: 'Nitrogen fill', amount: '$199', note: 'lol', d: 2 },
  { label: 'Market adjustment', amount: '$2,500', note: 'nope', d: 3 },
  { label: 'Doc fee', amount: '$699' },
  { label: 'Extended warranty', amount: '$2,990', note: 'skip', d: 4 },
  { label: `"${FED_NEW_CREDIT_LABEL} federal credit applied"`, amount: `-${FED_NEW_CREDIT_LABEL}`, note: 'dead', d: 5 },
];

export default function DealTeaser() {
  return (
    <section className="fi-deal" id="deal" aria-labelledby="fi-deal-h" data-track-context="home_deal_teaser">
      <div className="fi-wrap fi-deal-g">
        <div>
          <p className="fi-kick fi-kick--pop">Deal-Checker</p>
          <h2 className="fi-h2" id="fi-deal-h">Is your dealer fleecing you?</h2>
          <ul className="fi-ticks">
            <li>Paste the dealer's itemized price sheet, or just type the add-ons you're seeing.</li>
            <li>We flag every junk fee an EV buyer should refuse, with what it really costs.</li>
            <li>We catch the dead {FED_NEW_CREDIT_LABEL} credit lines dealers still try.</li>
          </ul>
          <RouterLink className="fi-btn fi-btn--pop fi-btn--on-dark" to="/deal-checker" onClick={() => { if (window.gtag) window.gtag('event', 'home_tool_deal_checker', { from: 'teaser' }); }}>
            Check my quote
          </RouterLink>
        </div>
        <div className="fi-receipt" aria-label="Example dealer quote with junk fees struck through">
          <div className="fi-r-head">Out-the-door worksheet</div>
          <div className="fi-rrow"><span>2026 Hyundai IONIQ 5</span><span>$35,000</span></div>
          {ROWS.map((r) => (
            <div key={r.label} className={`fi-rrow${r.note ? ` fi-junk fi-d${r.d}` : ''}`}>
              <span>{r.label}</span><span>{r.amount}</span>
              {r.note && <span className="fi-note" aria-hidden="true">{r.note}</span>}
            </div>
          ))}
          <div className="fi-r-total"><span>You keep</span><span className="fi-circ">$6,588</span></div>
          <div className="fi-r-dead">Plus a {FED_NEW_CREDIT_LABEL} credit that ended {FED_CREDIT_END}. Ask where it went.</div>
        </div>
      </div>
    </section>
  );
}
